import { useEffect, useRef } from "react";

export function Modal(props: {
    isOpen: boolean;
    setOpen: (isOpen: boolean) => void;
    children: any;
}) {
    const ref = useRef<HTMLDialogElement>();
    useEffect(() => {
        if (props.isOpen) {
            // @ts-ignore
            ref.current.showModal();
        } else {
            // @ts-ignore
            ref.current.close();
        }
    }, [props.isOpen]);

    return (
        // The style part is just to make sure the dialog is hidden the split second before useEffect runs,
        // in case the dialog content is derived from whatever determines isOpen
        <dialog ref={ref} style={!props.isOpen ? { display: "none" } : null}>
            <div className="close-button-div">
                <button
                    onClick={() => {
                        // we manually trigger a close anyway because the children can get updated before the dialog gets closed otherwise
                        // @ts-ignore
                        ref.current.close();
                        props.setOpen(false);
                    }}
                >
                    ✕
                </button>
            </div>
            <div>{props.children}</div>
        </dialog>
    );
}
